const HEX_COLOR = /^#([0-9a-f]{6})$/i

// WCAG relative luminance; above this, dark text out-contrasts white text.
const LIGHT_LUMINANCE_THRESHOLD = 0.179

function toLinearChannel(channel: number) {
  const value = channel / 255
  return value <= 0.03928 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4
}

/** The red, green and blue channels (0–255) of a `#rrggbb` colour, or null for any other format. */
export function parseHexColor(
  hexColor: string
): [number, number, number] | null {
  const hexDigits = HEX_COLOR.exec(hexColor)?.[1]
  if (!hexDigits) {
    return null
  }
  const value = parseInt(hexDigits, 16)
  return [(value >> 16) & 0xff, (value >> 8) & 0xff, value & 0xff]
}

/** Whether dark text reads better than white text on this `#rrggbb` colour. */
export function isLightColor(hexColor: string): boolean {
  const channels = parseHexColor(hexColor)
  if (!channels) {
    throw new Error(`Expected a #rrggbb colour, got "${hexColor}"`)
  }
  const [red, green, blue] = channels
  const luminance =
    0.2126 * toLinearChannel(red) +
    0.7152 * toLinearChannel(green) +
    0.0722 * toLinearChannel(blue)
  return luminance > LIGHT_LUMINANCE_THRESHOLD
}
